import React from 'react';

// Components
import EditPortfolioModal from '../EditPortfolioModal';

// Redux actions and connect
import { connect } from 'react-redux';
import { resetPortfolio } from '@/redux/modules/edit-portfolio';
import { togglePortfolioEditor } from '@/redux/modules/common/actionCreators';
import { saveContactPortfolio } from '@/redux/modules/contacts';
import { shouldClosePortfolioEditor } from '@/redux/modules/ai-statement-reader-multi-portfolio';

// Types
import { ReduxState } from '@/redux/modules/types';
import Portfolio from '@/types/portfolio';

type StateProps = {
  editPortfolioModalIsVisible: boolean;
  shouldCloseEditor: boolean;
};

type DispatchProps = {
  resetPortfolio: () => void;
  saveContactPortfolio: (portfolio: Portfolio) => Promise<Portfolio>;
  togglePortfolioEditor: (visible: boolean) => void;
};

type Props = {
  showActionOnSave?: boolean;
  onCancel?: () => void;
  onSave?: (portfolio: Portfolio) => Promise<Portfolio>;
} & StateProps &
  DispatchProps;

const DefaultEditContactPortfolioModal = ({
  editPortfolioModalIsVisible,
  shouldCloseEditor,
  showActionOnSave,
  onCancel,
  onSave,
  resetPortfolio,
  saveContactPortfolio,
  togglePortfolioEditor,
}: Props) => {
  const onCancelEditPortfolio = () => {
    resetPortfolio();
    togglePortfolioEditor(false);
    if (onCancel) {
      onCancel();
    }
  };
  const onEditPortfolioSave = async (portfolio: Portfolio): Promise<Portfolio> => {
    const newPortfolio = await saveContactPortfolio(portfolio);
    resetPortfolio();

    if (shouldCloseEditor) {
      togglePortfolioEditor(false);
    }

    if (onSave) {
      return onSave(newPortfolio);
    }
    return newPortfolio;
  };

  return (
    <EditPortfolioModal show={editPortfolioModalIsVisible} showActionOnSave={showActionOnSave} onCancel={onCancelEditPortfolio} onSave={onEditPortfolioSave} />
  );
};

const mapStateToProps = (state: ReduxState) => ({
  editPortfolioModalIsVisible: state.comparison.portfolioEditor.isVisible,
  shouldCloseEditor: shouldClosePortfolioEditor(state.aiStatementReaderMultiPortfolio),
});

export default connect(mapStateToProps, {
  resetPortfolio,
  saveContactPortfolio,
  togglePortfolioEditor,
})(DefaultEditContactPortfolioModal);
